import ChatBox from '../components/ChatBox';

const ChatBoxPlugin = {
  install(Vue, opt) {
    const { store } = opt;

    if (!store) {
      console.error('Vuex store is required for ChatBoxPlugin');
      return;
    }

    const ChatBoxConstructor = Vue.extend(ChatBox);

    const chatBoxInstance = new ChatBoxConstructor({
      store,
      propsData: {
        isVisible: false,
        strategy: null,
      },
    });

    chatBoxInstance.$mount();
    document.body.appendChild(chatBoxInstance.$el);

    Vue.prototype.$chatbox = {
      open(options = {}) {
        const { title, message, metadata, strategy } = options;

        if (!strategy) {
          console.error('[ChatBoxPlugin] A strategy must be provided.');
          return;
        }

        chatBoxInstance.strategy = strategy;

        if (title) chatBoxInstance.title = title;
        if (message) chatBoxInstance.message = message;
        if (metadata) chatBoxInstance.chatboxMetadata = metadata;

        chatBoxInstance.isVisible = true;
      },

      close() {
        chatBoxInstance.isVisible = false;
      },

      setMetadata(metadata) {
        chatBoxInstance.chatboxMetadata = metadata;
      },
    };

    chatBoxInstance.$on('close', () => {
      chatBoxInstance.isVisible = false;
    });
  },
};

export default ChatBoxPlugin;
